export default __webpack_public_path__ + "img/final2-7af4296d.png";